import { GenericOAuth2 } from '@capacitor-community/generic-oauth2';
import { PalmettoButton, PalmettoIcon } from '@palmetto/dsm-components';
import { useEffect } from 'react';
import { useComponentTracking, useTranslation } from '@helios/frontend-core';


import { SolarManufacturer } from './ManufacturerSelectionStep';

export interface OAuthConnectStepProps {
  setStep: (stepName: string, props?: Record<string, unknown>, direction?: 'forward' | 'backward') => void;
  manufacturer: SolarManufacturer;
}

const TRACKING_ID = 'takeover-oauth-connect-step';
const localePrefix = 'connectSolarSystem';

const ENPHASE_CLIENT_ID = '2ebbc031dc2132a797d98102ecf93dd0';

export function OAuthConnectStep({ manufacturer, setStep }: OAuthConnectStepProps) {
  useComponentTracking(`${TRACKING_ID}-${manufacturer}`);
  const { t } = useTranslation();

  const handleBackClick = () => {
    setStep('select-manufacturer', {}, 'backward');
  };

  useEffect(() => {
    if (manufacturer === 'enphase') {
      GenericOAuth2.authenticate({
        authorizationBaseUrl: 'https://api.enphaseenergy.com/oauth/authorize',
        accessTokenEndpoint: 'https://api.enphaseenergy.com/oauth/token',
        redirectUrl: 'http://localhost:3000/oauth/callback',
        appId: ENPHASE_CLIENT_ID,
        responseType: 'code',
        web: {
          windowOptions: 'height=600,left=0,top=0',
        },
        logsEnabled: true,
      }).then((response) => {
        console.log('OAuth Response:', response);
      });
    }
  }, []);

  return (
    <div className="flex flex-col h-full">
      <div className="px-24 pt-16">
        <PalmettoButton emphasis="text" size="small" layout="hug" onClick={handleBackClick}>
          <PalmettoIcon name="chevronLeft" size="sm" />
          {t('common.back')}
        </PalmettoButton>
      </div>
      <div className="flex flex-col gap-24 max-w-3xl mx-auto px-24 py-64 flex-1 justify-center items-center text-center">
        <PalmettoIcon name="settings" size="3xl" className="text-text-tertiary" />
        <div className="flex flex-col gap-12">
          <h2 className="heading-600">{t(`${localePrefix}.manufacturers.${manufacturer}.label`)}</h2>
          <p className="body-400 text-text-secondary">
            {t(`${localePrefix}.takeover.steps.oauthConnect.placeholder`)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default OAuthConnectStep;
